// extracted by mini-css-extract-plugin
export default {"add":"CourseButton_add__m9xCK","pick":"CourseButton_pick__usMWf"};